import { field, date, relation,text } from '@nozbe/watermelondb/decorators';
import { RATE_LIST_LINES_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class RateListLines extends Model {
    static table = RATE_LIST_LINES_SCHEMA;

    static associations = {
        rate_list: { type: 'belongs_to', key: 'rate_list_id' },
        business: { type: 'belongs_to', key: 'business_id' },
        stock: { type: 'belongs_to', key: 'stock_id' },
    }


    @field('minimum_order_quantity') minimum_order_quantity;
    @field('is_secondary_unit') is_secondary_unit;
    @text('discount_method') discount_method;
    @field('unit_conversion') unit_conversion;
    @text('secondary_unit') secondary_unit;
    @field('selling_price') selling_price;
    @field('cost_price') cost_price;
    @text('tran_type') tran_type;
    @field('inclusive') inclusive;
    @field('discount') discount;
    @field('quantity') quantity;
    @text('type') type;
    @text('name') name;
    @text('unit') unit;
    @field('tax') tax;

    @date('transacted_at') transacted_at;

    @relation('rate_list', 'rate_list_id') rate_list;
    @relation('business', 'business_id') business;
    @relation('stock', 'stock_id') stock;
};